import { useMutation } from '@tanstack/react-query'

import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

export const useUpdateReferredByCode = () => {
  return useMutation({
    mutationFn: async ({
      orgId,
      referredByCode,
    }: {
      orgId: string
      referredByCode: string
    }) => {
      return HttpService.put({
        path: pathBuilder(EServerPath.updateReferredByCode, { orgId }),
        payload: { referredByCode },
      })
    },
  })
}

export default useUpdateReferredByCode
